import React from "react";
import Select from "react-select";

import { Icon } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy, faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

import { Button, Popover, OverlayTrigger } from "react-bootstrap";
import { Button as AibleButton } from "aible";

import Toggle from "react-toggle";

import Confetti from "images/confetti.png";

import AibleStep from "components/CreateWizard/AibleStep";

import { SECTIONS } from "components/Results/Results";

import styles from "./style.module.css";

import { NumberLabel } from "aible";

export default class Results extends React.PureComponent {
  renderTrophy() {
    return (
      <div className={styles.tHolder}>
        <div className={styles.trophy}>
          <FontAwesomeIcon icon={faTrophy} />
        </div>
      </div>
    );
  }

  getFormattedDrivers(prediction) {
    const { colSelections } = this.props;

    if (prediction === undefined) {
      return undefined;
    }

    var drivers = prediction;

    drivers.sort(function (a, b) {
      if (a.impact > b.impact) return 1;
      if (b.impact > a.impact) return -1;

      return 0;
    });

    var formattedDrivers = [];

    var isLargestPositive = true;
    var isLargestNegative = true;

    for (var i = 0; i < drivers.length; i++) {
      var driver = drivers[i];
      var value = colSelections[driver.variable];

      if (formattedDrivers.length >= 3) {
        break;
      } else if (value !== undefined && driver.impact != 0) {
        var label = driver.variable + ": ";
        label += value + " had ";
        var direction;

        if (driver.impact < 0) {
          if (isLargestNegative) {
            label += "the largest ";
            isLargestNegative = false;
          } else {
            label += "a ";
          }

          label += "negative impact";
          direction = "Negative";
        } else {
          if (isLargestPositive) {
            label += "the largest ";
            isLargestPositive = false;
          } else {
            label += "a ";
          }

          label += "positive impact";
          direction = "Positive";
        }

        formattedDrivers.push({
          label: label,
          direction: direction
        });
      }
    }

    return formattedDrivers;
  }

  renderPredictionNarrative(formattedDrivers) {
    return (
      <div className={styles.dHoldNarrative} style={{ paddingLeft: "0px" }}>
        <div className={styles.dHeader}>{"Top Prediction Drivers"}</div>
        {formattedDrivers.map((f, i) => (
          <div className={styles.dFieldPredict} key={i}>
            {f.direction === "Positive" ? (
              <div className={styles.dItem}>
                <span className={styles.dIconGood}>
                  <FontAwesomeIcon icon={faArrowUp} />
                </span>
              </div>
            ) : (
              <div className={styles.dItem}>
                <span className={styles.dIconBad}>
                  <FontAwesomeIcon icon={faArrowDown} />
                </span>
              </div>
            )}
            <div className={styles.dItem}>{f.label}</div>
          </div>
        ))}
      </div>
    );
  }

  renderDrivers() {
    const { model, featureBars, scenarios, scenarioIndex } = this.props;

    const scenario =
      scenarios && scenarios.filter((s) => s.id === scenarioIndex).length > 0
        ? scenarios.filter((s) => s.id === scenarioIndex)[0]
        : undefined;

    const prediction = scenario ? scenario.predictions : undefined;

    const retPrediction =
      prediction && prediction[0] && prediction[0].info && prediction[0].info.rowLevelDrivers
        ? prediction[0].info.rowLevelDrivers
        : undefined;

    const formattedDrivers = this.getFormattedDrivers(retPrediction);

    return (
      <div className={styles.drivers}>
        {formattedDrivers && formattedDrivers.length > 1 ? (
          this.renderPredictionNarrative(formattedDrivers)
        ) : (
          <div className={styles.dHold}>
            <div className={styles.dHeader}>{"Top Model Drivers"}</div>
            {featureBars &&
              featureBars
                .filter((f, i) => i < 3)
                .map((f, i) => {
                  let maxValue = undefined;
                  let maxKey = undefined;

                  let minValue = undefined;
                  let minKey = undefined;

                  for (const val of Object.keys(f.values)) {
                    if (maxValue === undefined || f.values[val] >= maxValue) {
                      maxValue = f.values[val];
                      maxKey = val;
                    }

                    if (minValue === undefined || f.values[val] <= minValue) {
                      minValue = f.values[val];
                      minKey = val;
                    }
                  }

                  return (
                    <div className={styles.dField} key={i}>
                      <div className={styles.dItem}>
                        <span className={styles.bold}>{f.label}</span>
                        <span>
                          {i === 0
                            ? " is the most impactful driver"
                            : i === 1
                              ? " is the second most impactful driver"
                              : i === 2
                                ? " is the third most impactful driver"
                                : " is an impactful driver"}
                        </span>
                      </div>
                      <div className={styles.dItem}>
                        <span className={styles.dIconGood}>
                          <FontAwesomeIcon icon={faArrowUp} />
                        </span>
                        <span className={styles.bold}>{maxKey}</span>
                        <span>{" is the strongest positive"}</span>
                      </div>
                      <div className={styles.dItem}>
                        <span className={styles.dIconBad}>
                          <FontAwesomeIcon icon={faArrowDown} />
                        </span>
                        <span className={styles.bold}>{minKey}</span>
                        <span>{" is the strongest negative"}</span>
                      </div>
                    </div>
                  );
                })}
          </div>
        )}
      </div>
    );
  }

  renderNormal() {
    const {
      section,
      model,
      models,
      isContinuous,
      netImpactLabel,
      isQuickRun,
      trueAction,
      updateChooseModel,
      isForceOptimized,
      ignoredModels,
      updateIgnoredModel,
      setIsAllowedInFrontier,
      modelIsAllowedInFrontier,
      currentStateImpact,
      setup,
      setupLabels,
      isUnified,
      unitRevenue,
      holdoutDataPath
    } = this.props;

    const numberFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      precision: isContinuous ? 2 : 1,
      justification: "L"
    };

    const preciseFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      justification: "L",
      format: "00.00%"
    };

    const impact = model
      ? !isNaN(model.roi)
        ? model.roi
        : model.maxIteration && model.maxIteration.displayImpact
          ? Math.round(model.maxIteration.displayImpact)
          : isQuickRun && !isForceOptimized && model.meanAbsoluteError !== undefined
            ? model.meanAbsoluteError
            : model.checkMax
      : undefined;

    const processed =
      model && model.maxIteration ? Math.round((1 - model.maxIteration.processed) * 1000) / 10 : undefined;

    const processMissed = model && model.maxIteration ? model.maxIteration.processMissed : undefined;

    const isIgnored = model && ignoredModels[model.id];

    const getMetric = (model, metric) => {
      if (model === undefined || model.maxIteration === undefined) {
        return undefined;
      }

      return Math.abs(model.maxIteration[metric] * 100);
    };

    const precision = getMetric(model, "precision") / 100;
    const accuracy = getMetric(model, "accuracy") / 100;
    const recall = getMetric(model, "recall") / 100;

    const revenue = model && model.maxIteration ? model.maxIteration.totalWins * unitRevenue : 0;
    const cost =
      model && model.maxIteration
        ? Math.abs((model.maxIteration.truePositive + model.maxIteration.falsePositive) * setup.conversionCost)
        : 0;

    return (
      <div className={styles.infoBox} style={isUnified ? { height: "100%" } : undefined}>
        <div className={styles.info} style={isUnified ? { margin: "0px" } : undefined}>
          {!isUnified && (
            <div className={styles.sHeader + " " + styles.sHeaderToggle}>
              <span>{"Allow in Frontier"}</span>
              <Toggle
                checked={modelIsAllowedInFrontier}
                onChange={() => {
                  if (model) {
                    setIsAllowedInFrontier(model.id, !modelIsAllowedInFrontier);
                    updateIgnoredModel(model.id, !isIgnored);
                  }
                }}
              />
            </div>
          )}
          <div className={styles.sHeader}>
            {isContinuous ? "Total Cost" : setupLabels && setupLabels.profitLabel ? setupLabels.profitLabel : "Impact"}
          </div>
          <div className={styles.infoNum}>
            <NumberLabel params={numberFormatParams}>{impact}</NumberLabel>
          </div>
          {!isContinuous && (
            <div>
              <NumberLabel isSpan params={numberFormatParams}>
                {impact > currentStateImpact
                  ? Math.abs(impact - currentStateImpact)
                  : Math.abs(currentStateImpact - impact)}
              </NumberLabel>
              {impact > currentStateImpact ? " more than current state" : " less than current state"}
            </div>
          )}
        </div>
        {processed && isQuickRun !== true ? (
          <div className={styles.info}>
            <div className={styles.sHeader}>{"Resourcing"}</div>
            <div className={styles.infoNum}>
              {processMissed < 0 ? Math.round(Math.abs(processMissed * 1000)) / 10 + "% more" : processed + "%"}
            </div>
            <div>{"remaining capacity to " + trueAction}</div>
          </div>
        ) : (
          <div />
        )}
        {!isContinuous && (
          <div className={styles.info}>
            <div className={styles.sHeader}>{setupLabels.revenueLabel}</div>
            <div className={styles.infoNum}>
              <NumberLabel params={numberFormatParams}>{revenue}</NumberLabel>
            </div>
          </div>
        )}
        {!isContinuous && (
          <div className={styles.info}>
            <div className={styles.sHeader}>{setupLabels.costLabel}</div>
            <div className={styles.infoNum}>
              <NumberLabel params={numberFormatParams}>{cost}</NumberLabel>
            </div>
          </div>
        )}
        {!isContinuous ? (
          <React.Fragment>
            <br />
            <div className={styles.sHeader}>
              {"Precision: "}
              <NumberLabel params={preciseFormatParams}>{precision}</NumberLabel>
            </div>
            <div className={styles.sHeader}>
              {"Accuracy: "}
              <NumberLabel params={preciseFormatParams}>{accuracy}</NumberLabel>
            </div>
            <div className={styles.sHeader}>
              {"Recall: "}
              <NumberLabel params={preciseFormatParams}>{recall}</NumberLabel>
            </div>
          </React.Fragment>
        ) : (
          ""
        )}
        {holdoutDataPath !== undefined && this.state && this.state.holdoutDataLink ? (
          holdoutDataPath
        ) : (
          <AibleButton onClick={() => this.setState({ holdoutDataLink: true })}>Path to Holdout Data</AibleButton>
        )}
      </div>
    );
  }

  renderFeedback() {
    const { modelFeedback } = this.props;

    if (!modelFeedback || modelFeedback.length === 0) {
      return <React.Fragment />;
    }

    const feedback = {
      positive: [],
      negative: [],
      total: 0
    };

    modelFeedback.forEach((f) => {
      if (f.feedback > 0) {
        feedback.total += f.feedback;
        feedback.positive.push(f);
      } else if (f.feedback < 0) {
        feedback.total += f.feedback;
        feedback.negative.push(f);
      }
    });

    return (
      <OverlayTrigger
        placement="top"
        trigger={["click"]}
        rootClose
        overlay={
          <Popover id="popover-positioned-top" title={"User Feedback"}>
            <div className={styles.tileOverlay}>
              {feedback.positive.map((cFeedback) => (
                <FeedbackDetails data={cFeedback} key={cFeedback.id} />
              ))}
              {feedback.positive.length && feedback.negative.length ? (
                <div className={styles.feedbackDivider} />
              ) : (
                <React.Fragment />
              )}
              {feedback.negative.map((cFeedback) => (
                <FeedbackDetails data={cFeedback} key={cFeedback.id} />
              ))}
            </div>
          </Popover>
        }
      >
        <div className={styles.feedbackLinkWrapper}>
          <a>
            <span>
              {"Feedback"}
              &nbsp; &nbsp;
              {feedback.total < 0 ? "" : "+"}
              {feedback.total}
            </span>
            <Icon
              style={feedback.total < 0 ? { marginTop: "5px" } : { marginBottom: "5px" }}
              type={feedback.total < 0 ? "thumbsDownPurple" : "thumbsUpPurple"}
            />
          </a>
        </div>
      </OverlayTrigger>
    );
  }

  render() {
    const {
      section,
      model,
      models,
      isContinuous,
      netImpactLabel,
      isQuickRun,
      runCost,
      updateChooseModel,
      fids,
      isUnified,
      modelFeedback
    } = this.props;

    let modelIndex = undefined;

    models &&
      models.forEach((m, i) => {
        if (model && m.id === model.id) {
          modelIndex = i;
        }
      });

    const isModelFrontier = fids.has(model.id);

    return (
      <div className={styles.mini}>
        <div className={styles.miniBody} style={isUnified ? { padding: "0px 0px 0px 20px" } : undefined}>
          <div className={styles.selectModels}>
            {!isUnified ? (
              <React.Fragment>
                <div className={styles.sHeader}>
                  {"Selected Model"}
                  {isModelFrontier ? <span className={styles.frontierBadge}>{"Frontier"}</span> : ""}
                </div>
                <div className={styles.optionHolder}>
                  <Select
                    options={models.map((m) => ({
                      value: m.id,
                      label: m.label
                    }))}
                    value={
                      model
                        ? {
                            value: model.id,
                            label: model.label
                          }
                        : undefined
                    }
                    onChange={(val) => updateChooseModel(val.value)}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 100
                      })
                    }}
                    isSearchable={false}
                  />
                </div>
              </React.Fragment>
            ) : (
              ""
            )}
            {modelIndex === 0 && <div className={styles.rMsg}>{"Won over " + models.length + " models"}</div>}
            {this.renderFeedback()}
          </div>
          {section === SECTIONS.PREDICTION_DRIVERS || section === SECTIONS.WHAT_IF
            ? this.renderDrivers()
            : this.renderNormal()}
        </div>
      </div>
    );
  }
}

class FeedbackDetails extends React.PureComponent {
  render() {
    const { data } = this.props;
    if (!data) {
      return <React.Fragment />;
    }
    return (
      <div className={styles.feedbackDetailsWrapper}>
        <div className={styles.feedbackDetailsUser}>{data.fullname}</div>
        <Icon
          size={16}
          style={
            data.feedback < 0 ? { marginLeft: "6px", marginTop: "4px" } : { marginLeft: "6px", marginBottom: "4px" }
          }
          type={data.feedback < 0 ? "thumbsDownPurple" : "thumbsUpPurple"}
        />
      </div>
    );
  }
}
